import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2ProvisionEventFlagMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  flag: Types.Scalars['String'];
}>;

export type WebsiteV2ProvisionEventFlagMutation = { __typename?: 'Mutation'; createEventFeatureFlag: { __typename?: 'FeatureFlag'; id: string; flag: string } };

export const WebsiteV2ProvisionEventFlagDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2ProvisionEventFlag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventFeatureFlag' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'flag' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2ProvisionEventFlagMutationFn = Apollo.MutationFunction<WebsiteV2ProvisionEventFlagMutation, WebsiteV2ProvisionEventFlagMutationVariables>;

/**
 * __useWebsiteV2ProvisionEventFlagMutation__
 *
 * To run a mutation, you first call `useWebsiteV2ProvisionEventFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2ProvisionEventFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2ProvisionEventFlagMutation, { data, loading, error }] = useWebsiteV2ProvisionEventFlagMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      flag: // value for 'flag'
 *   },
 * });
 */
export function useWebsiteV2ProvisionEventFlagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2ProvisionEventFlagMutation, WebsiteV2ProvisionEventFlagMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2ProvisionEventFlagMutation, WebsiteV2ProvisionEventFlagMutationVariables>(WebsiteV2ProvisionEventFlagDocument, baseOptions);
}
export type WebsiteV2ProvisionEventFlagMutationHookResult = ReturnType<typeof useWebsiteV2ProvisionEventFlagMutation>;
export type WebsiteV2ProvisionEventFlagMutationResult = Apollo.MutationResult<WebsiteV2ProvisionEventFlagMutation>;
export type WebsiteV2ProvisionEventFlagMutationOptions = Apollo.BaseMutationOptions<WebsiteV2ProvisionEventFlagMutation, WebsiteV2ProvisionEventFlagMutationVariables>;
